/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/homeManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '首页管理',
      icon: 'component',
    },
    children: [
      {
        path: '/homeManage/bannerManage',
        component: () => import('@/myviews/shoppMall/homeManage/bannerManage/bannerManage.vue'),
        alwaysShow: false,
        name: 'bannerManage',
        meta: {
          title: 'banner管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/homeManage/floorManage',
        component: () => import('@/myviews/shoppMall/homeManage/floorManage/floorManage.vue'),
        alwaysShow: false,
        name: 'floorManage',
        meta: {
          title: '楼层管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/homeManage/recommendManage',
        component: () => import('@/myviews/shoppMall/homeManage/recommendManage/recommendManage.vue'),
        alwaysShow: false,
        name: 'recommendManage',
        meta: {
          title: '推荐管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/homeManage/homeVajraMap',
        component: () => import('@/myviews/shoppMall/homeManage/homeVajraMap/homeVajraMap.vue'),
        alwaysShow: false,
        name: 'HomeVajraMap',
        meta: {
          title: '首页金刚图',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/activePageConfiguration/activePageConfiguration',
        component: () => import('@/myviews/shoppMall/homeManage/activePageConfiguration/activePageConfiguration.vue'),
        alwaysShow: false,
        name: 'activePageConfiguration',
        meta: {
          title: '活动页配置',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      }
    ]
  },
  {
    path: '/homeManage',
    notShow:true,
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '首页管理',
      icon: 'component',
    },
    children: [
      {
        path: '/bannerManage/editBanner',
        component: () => import('@/myviews/shoppMall/homeManage/bannerManage/addBanner.vue'),
        alwaysShow: false,
        name: "编辑banner",
        meta: {
          title: '编辑banner',
          icon: 'peoples',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      },
      {
        path: '/floorManage/editFloor',
        component: () => import('@/myviews/shoppMall/homeManage/floorManage/addFloor.vue'),
        alwaysShow: false,
        name: "编辑楼层",
        meta: {
          title: '编辑楼层',
          icon: 'peoples',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      },
      {
        path: '/activityManage/editActivity',
        component: () => import('@/myviews/shoppMall/activityManage/seckillActivity/addActivity.vue'),
        alwaysShow: false,
        name: "编辑活动",
        meta: {
          title: '编辑活动',
          icon: 'peoples',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      },
      {
        path: '/activityManage/addOrEditLotteryActivity',
        component: () => import('@/myviews/shoppMall/activityManage/seckillActivity/addOrEditLotteryActivity.vue'),
        alwaysShow: false,
        name: "addOrEditLotteryActivity",
        meta: {
          title: '新增 / 编辑抽奖活动',
          icon: 'component',
          roles: ['add',"modify","viewpage"],
          have:[],
        }
      },
      {
        path: '/activityManage/addOrEditSpecialActivity',
        component: () => import('@/myviews/shoppMall/activityManage/seckillActivity/addOrEditSpecialActivity.vue'),
        alwaysShow: false,
        name: "addOrEditSpecialActivity",
        meta: {
          title: '新增 / 编辑特价活动',
          icon: 'component',
          roles: ['add',"modify","viewpage"],
          have:[],
        }
      },
      {
        path: '/recommendManage/edit',
        component: () => import('@/myviews/shoppMall/homeManage/recommendManage/add.vue'),
        alwaysShow: false,
        name: "编辑推荐",
        meta: {
          title: '编辑推荐',
          icon: 'peoples',
          roles: ['add',"modify","viewpage"],//添加   修改   查看页面
          have:[],
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/homeManage.js